var _g, _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _path2, _rect, _rect2, _rect3, _rect4, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _rect5, _rect6, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _line21, _line22, _rect7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNanoBeatsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_206_141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9C0 4.58172 3.58172 1 8 1H42C46.4183 1 50 4.58172 50 9V43C50 47.4183 46.4183 51 42 51H8C3.58172 51 0 47.4183 0 43V9Z",
    fill: "#7D7D7D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5H42C46.1421 1.5 49.5 4.85786 49.5 9V43C49.5 47.1421 46.1421 50.5 42 50.5H8C3.85787 50.5 0.5 47.1421 0.5 43V9C0.5 4.85787 3.85786 1.5 8 1.5Z",
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 6,
    x2: 8.5,
    y2: 35,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 6.5,
    x2: 14,
    y2: 6.5,
    stroke: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14.4127,
    y1: 6.71766,
    x2: 27.4127,
    y2: 25.7177,
    stroke: "white"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 27.5,
    y1: 26,
    x2: 27.5,
    y2: 6,
    stroke: "white"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 6.5,
    x2: 34,
    y2: 6.5,
    stroke: "white"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 33.5,
    y1: 6,
    x2: 33.5,
    y2: 36,
    stroke: "white"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 35.5,
    x2: 27,
    y2: 35.5,
    stroke: "white"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 35.5,
    x2: 15,
    y2: 35.5,
    stroke: "white"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 36,
    x2: 14.5,
    y2: 17,
    stroke: "white"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 14.4127,
    y1: 16.7177,
    x2: 27.4127,
    y2: 35.7177,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1913 6.5325C14.2121 6.52437 14.3611 6.49463 14.2859 6.49463",
    stroke: "white",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7,
    width: 5,
    height: 28,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.22937,
    y: 9.96045,
    width: 6.14477,
    height: 31.3907,
    transform: "rotate(-34.4555 9.22937 9.96045)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 6,
    width: 7,
    height: 30,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3207,
    y: 17.5417,
    width: 6.2842,
    height: 22.2868,
    transform: "rotate(-34.3059 14.3207 17.5417)",
    fill: "white"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 5,
    x2: 7.5,
    y2: 37,
    stroke: "black"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 5.5,
    x2: 14,
    y2: 5.5,
    stroke: "black"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 36.5,
    x2: 16,
    y2: 36.5,
    stroke: "black"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 36,
    x2: 15.5,
    y2: 19,
    stroke: "black"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 36.5,
    x2: 35,
    y2: 36.5,
    stroke: "black"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 34.5,
    y1: 36,
    x2: 34.5,
    y2: 5,
    stroke: "black"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 5.5,
    x2: 35,
    y2: 5.5,
    stroke: "black"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 26.5,
    y1: 6,
    x2: 26.5,
    y2: 23,
    stroke: "black"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 14.4085,
    y1: 5.71166,
    x2: 26.4085,
    y2: 22.7117,
    stroke: "black"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 26.588,
    y1: 36.2833,
    x2: 15.588,
    y2: 20.2833,
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 16,
    width: 3,
    height: 4,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 23,
    width: 3,
    height: 2,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7681 36.3767C26.7834 36.386 26.7992 36.4039 26.8153 36.4111C26.8216 36.4139 26.8508 36.4209 26.8308 36.4209C26.8127 36.4209 26.7626 36.4283 26.7583 36.4111",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9448 36.5583C26.9448 36.5793 26.9476 36.6216 26.9301 36.6366C26.9241 36.6417 26.8857 36.6577 26.8938 36.669C26.903 36.6819 26.9096 36.6927 26.9214 36.7045C26.9282 36.7113 26.9262 36.7241 26.9312 36.729C26.9492 36.747 26.9461 36.7114 26.9448 36.7056",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6675 35.9398C26.6722 35.9685 26.6655 36.0895 26.7091 36.0895C26.7518 36.0895 26.7507 36.099 26.7507 36.1395",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0334 36.2559H27.1499",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3181 36.3224C26.4332 36.4095 26.5377 36.52 26.6675 36.5849C26.6975 36.5999 26.7352 36.6218 26.7673 36.6218C26.801 36.6218 26.8206 36.6534 26.8505 36.6551C26.9171 36.659 26.9622 36.705 27.0335 36.705",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3015 36.2725C26.4089 36.4099 26.5766 36.4625 26.6934 36.5793C26.8054 36.6913 26.9463 36.7216 27.1 36.7216",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6107 5.32703C13.6587 5.34691 13.7252 5.36923 13.7677 5.40231C13.8051 5.43137 13.8249 5.41537 13.866 5.4271C13.9046 5.43813 14.0034 5.48212 14.0239 5.518C14.0379 5.54246 14.1065 5.61235 14.1065 5.64103C14.1065 5.65951 14.0756 5.67079 14.0735 5.70714C14.073 5.71472 14.0565 5.73367 14.0569 5.7255C14.0607 5.66192 14.1606 5.65512 14.2057 5.64103",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2057 5.64105C14.1901 5.65327 14.1323 5.73966 14.1231 5.74021C14.0478 5.74464 14.1322 5.52494 14.1396 5.49231",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9247 5.29404C13.9289 5.29486 14.0536 5.32794 14.0367 5.29404C14.0305 5.28158 13.9742 5.26099 14.0156 5.26099C14.0644 5.26099 14.0972 5.27751 14.1478 5.27751C14.1974 5.27751 14.247 5.27751 14.2965 5.27751C14.3665 5.27751 14.3249 5.33548 14.3388 5.38402C14.344 5.40228 14.3758 5.38697 14.3874 5.40146C14.3973 5.41383 14.4118 5.42924 14.4242 5.43911C14.4509 5.46051 14.4797 5.47808 14.5068 5.50521C14.5262 5.52467 14.5136 5.54138 14.5206 5.56581C14.5235 5.57623 14.5557 5.58292 14.5656 5.59519C14.5791 5.61219 14.6072 5.66744 14.6188 5.69068",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1726 5.32703C14.3141 5.32703 14.4935 5.42341 14.5527 5.54187",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1621 30.2422C39.1387 30.8438 40.6139 31.8249 41.5879 33.1855C42.5762 34.5319 43.0703 36.0859 43.0703 37.8477C43.0703 39.6094 42.6263 41.2279 41.7383 42.7031C40.8503 44.1784 39.5898 45.2669 37.957 45.9688C36.3242 46.6562 34.1113 47 31.3184 47H19.2656V15.5039H31.082C34.9062 15.5039 37.599 16.3346 39.1602 17.9961C40.7357 19.6576 41.5234 21.5052 41.5234 23.5391C41.5234 24.9141 41.1582 26.1888 40.4277 27.3633C39.7116 28.5234 38.623 29.4831 37.1621 30.2422ZM23.4336 28.6953H30.2656C31.6693 28.6953 32.8438 28.6165 33.7891 28.459C34.7487 28.3014 35.5938 27.8861 36.3242 27.2129C37.0547 26.5397 37.4199 25.4941 37.4199 24.0762C37.4199 22.5866 37.0475 21.4909 36.3027 20.7891C35.5723 20.0729 34.6914 19.6361 33.6602 19.4785C32.6432 19.321 31.3327 19.2422 29.7285 19.2422H23.4336V28.6953ZM23.4336 43.2617H31.2754C34.0827 43.2617 36.0306 42.7819 37.1191 41.8223C38.2077 40.8626 38.752 39.5378 38.752 37.8477C38.752 36.1432 38.1719 34.8184 37.0117 33.873C35.8516 32.9134 33.7604 32.4336 30.7383 32.4336H23.4336V43.2617Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1621 30.2422L36.701 29.3548L34.5258 30.4851L36.8709 31.1989L37.1621 30.2422ZM41.5879 33.1855L40.7747 33.7676L40.7818 33.7773L41.5879 33.1855ZM37.957 45.9688L38.3451 46.8904L38.3519 46.8875L37.957 45.9688ZM19.2656 47H18.2656V48H19.2656V47ZM19.2656 15.5039V14.5039H18.2656V15.5039H19.2656ZM39.1602 17.9961L38.4314 18.6809L38.4345 18.6842L39.1602 17.9961ZM40.4277 27.3633L39.5786 26.8351L39.5768 26.838L40.4277 27.3633ZM23.4336 28.6953H22.4336V29.6953H23.4336V28.6953ZM33.7891 28.459L33.6271 27.4722L33.6247 27.4726L33.7891 28.459ZM36.3027 20.7891L35.6027 21.5031L35.6097 21.5101L35.6169 21.5169L36.3027 20.7891ZM33.6602 19.4785L33.5071 20.4667L33.5091 20.467L33.6602 19.4785ZM23.4336 19.2422V18.2422H22.4336V19.2422H23.4336ZM23.4336 43.2617H22.4336V44.2617H23.4336V43.2617ZM37.1191 41.8223L36.4578 41.0721L37.1191 41.8223ZM37.0117 33.873L36.3743 34.6436L36.38 34.6483L37.0117 33.873ZM23.4336 32.4336V31.4336H22.4336V32.4336H23.4336ZM36.8709 31.1989C38.6875 31.7517 39.9565 32.6244 40.7747 33.7676L42.401 32.6035C41.2714 31.0253 39.5898 29.9358 37.4533 29.2855L36.8709 31.1989ZM40.7818 33.7773C41.6369 34.9423 42.0703 36.2864 42.0703 37.8477H44.0703C44.0703 35.8855 43.5154 34.1215 42.394 32.5938L40.7818 33.7773ZM42.0703 37.8477C42.0703 39.4321 41.6736 40.8716 40.8815 42.1874L42.595 43.2188C43.579 41.5841 44.0703 39.7867 44.0703 37.8477H42.0703ZM40.8815 42.1874C40.1051 43.4772 39.0092 44.428 37.5621 45.05L38.3519 46.8875C40.1705 46.1058 41.5954 44.8795 42.595 43.2188L40.8815 42.1874ZM37.569 45.0471C36.1093 45.6617 34.0463 46 31.3184 46V48C34.1763 48 36.5392 47.6508 38.3451 46.8904L37.569 45.0471ZM31.3184 46H19.2656V48H31.3184V46ZM20.2656 47V15.5039H18.2656V47H20.2656ZM19.2656 16.5039H31.082V14.5039H19.2656V16.5039ZM31.082 16.5039C34.8082 16.5039 37.1538 17.3212 38.4314 18.6809L39.8889 17.3113C38.0441 15.3481 35.0043 14.5039 31.082 14.5039V16.5039ZM38.4345 18.6842C39.8579 20.1852 40.5234 21.7941 40.5234 23.5391H42.5234C42.5234 21.2163 41.6135 19.1299 39.8858 17.308L38.4345 18.6842ZM40.5234 23.5391C40.5234 24.7262 40.2111 25.8182 39.5786 26.8351L41.2769 27.8914C42.1053 26.5594 42.5234 25.1019 42.5234 23.5391H40.5234ZM39.5768 26.838C38.9735 27.8154 38.035 28.6617 36.701 29.3548L37.6232 31.1295C39.2111 30.3045 40.4497 29.2315 41.2787 27.8886L39.5768 26.838ZM23.4336 29.6953H30.2656V27.6953H23.4336V29.6953ZM30.2656 29.6953C31.7015 29.6953 32.9352 29.6151 33.9535 29.4454L33.6247 27.4726C32.7523 27.618 31.637 27.6953 30.2656 27.6953V29.6953ZM33.9511 29.4458C35.1078 29.2559 36.1311 28.7508 37.0019 27.9482L35.6465 26.4775C35.0564 27.0213 34.3896 27.347 33.6271 27.4722L33.9511 29.4458ZM37.0019 27.9482C38.013 27.0165 38.4199 25.6516 38.4199 24.0762H36.4199C36.4199 25.3366 36.0964 26.0629 35.6465 26.4775L37.0019 27.9482ZM38.4199 24.0762C38.4199 22.4378 38.0104 21.0242 36.9885 20.0613L35.6169 21.5169C36.0846 21.9576 36.4199 22.7354 36.4199 24.0762H38.4199ZM37.0028 20.075C36.1195 19.209 35.0453 18.6785 33.8112 18.49L33.5091 20.467C34.3375 20.5936 35.0251 20.9369 35.6027 21.5031L37.0028 20.075ZM33.8133 18.4903C32.7259 18.3218 31.359 18.2422 29.7285 18.2422V20.2422C31.3064 20.2422 32.5606 20.3201 33.5071 20.4667L33.8133 18.4903ZM29.7285 18.2422H23.4336V20.2422H29.7285V18.2422ZM22.4336 19.2422V28.6953H24.4336V19.2422H22.4336ZM23.4336 44.2617H31.2754V42.2617H23.4336V44.2617ZM31.2754 44.2617C34.1289 44.2617 36.4018 43.7878 37.7804 42.5724L36.4578 41.0721C35.6594 41.776 34.0365 42.2617 31.2754 42.2617V44.2617ZM37.7804 42.5724C39.1206 41.391 39.752 39.7727 39.752 37.8477H37.752C37.752 39.3028 37.2948 40.3343 36.4578 41.0721L37.7804 42.5724ZM39.752 37.8477C39.752 35.8896 39.0708 34.2609 37.6434 33.0978L36.38 34.6483C37.273 35.3759 37.752 36.3969 37.752 37.8477H39.752ZM37.6491 33.1025C36.2007 31.9045 33.7952 31.4336 30.7383 31.4336V33.4336C33.7257 33.4336 35.5024 33.9224 36.3743 34.6436L37.6491 33.1025ZM30.7383 31.4336H23.4336V33.4336H30.7383V31.4336ZM22.4336 32.4336V43.2617H24.4336V32.4336H22.4336Z",
    fill: "#A61111"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 26.5,
    y1: 10,
    x2: 26.5,
    y2: 23,
    stroke: "black"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 34.5,
    y1: 8,
    x2: 34.5,
    y2: 23,
    stroke: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 7,
    width: 7,
    height: 16,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_206_141",
    x: 0,
    y: 1,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_206_141"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNanoBeatsLogo);
export default __webpack_public_path__ + "static/media/nano-beats-logo.f845fd5da614db1c58d20ec4e87c4a4d.svg";
export { ForwardRef as ReactComponent };